export const InventoryUploadHistoryData = {
    totalRecords: 12,
    totalPages: 1,
    pageSize: 10,
    currentPage: 0,
    data: [
      {
        id: 0,
        file_path: '/documents/2024/',
        import_date: 'report.pdf',
        job_start_date: '2024-03-10',
        job_end_date: '2024-03-20',
        total_records: 100,
        failed_records_count: 3,
        failed_records: [
          {product_id: '2', warehouse_id: '1', status: 'Failed'},
          {product_id: '39', warehouse_id: '1', status: 'Failed'},
          {product_id: '42', warehouse_id: '1', status: 'Failed'},
          {product_id: '41', warehouse_id: '1', status: 'Failed'},
        ],
      },
      {
        id: 1,
        file_path: '/images/marketing/',
        import_date: 'banner.jpg',
        job_start_date: '2024-03-15',
        job_end_date: '2024-03-19',
        total_records: 100,
        failed_records_count: 0,
        failed_records: [
          // even if empty, your mapping will work fine
        ],
      },
      {
        id: 2,
        file_path: '/images/marketing/',
        import_date: 'banner2.jpg',
        job_start_date: '2024-03-18',
        job_end_date: '2024-03-21',
        total_records: 100,
        failed_records_count: 2,
        failed_records: [
          {product_id: '10', warehouse_id: '1', status: 'Failed'},
          {product_id: '11', warehouse_id: '1', status: 'Failed'},
          {product_id: '12', warehouse_id: '1', status: 'Failed'},
        ],
      },
    ],
  }
  